import React from "react";

import StdHostelDetails from "../../components/StudentTabs/StudentHostelDetails/StdHostelDetails";

const HolidayList = () => {
  return (
    <div>
      
      <StdHostelDetails/>
    </div>
  );
};

export default HolidayList;
